
import { defineComponent } from 'vue'
import appointmentTypeService from '../common/appointmentTypeService'
import TimeService from '../common/timeService'
import { AppointmentType } from '../models/appointmentType'
import AppointmentTypeForm from '../components/AppointmentTypeForm.vue'

export default defineComponent({
  name: 'AppointmentTypesList',

  data () {
    return {
      /** AppointmentType Form Info */
      appointmentForm: null as unknown as AppointmentType,

      /** List of AppoointmentTypes */
      appointmentTypes: [] as Array<AppointmentType>,

      /** Indicator to show the appointment form */
      shouldShowAppointmentForm: false,

      shouldRestoreType: false
    }
  },

  mounted () {
    // Fetch appointment types
    appointmentTypeService.getAll().then(res => {
      this.appointmentTypes = res.data
    })
  },

  computed: {
    // returns list of appointment types removed
    appointmentTypesRemoved: function (): Array<AppointmentType> {
      return this.appointmentTypes.filter(type => type.removed)
    },

    // returns list of appointment types still active
    appointmentTypesActive: function (): Array<AppointmentType> {
      return this.appointmentTypes.filter(type => !type.removed)
    }
  },

  methods: {
    /**
     * Creates a new AppoiontmentType
     */
    handleAppointmentTypeCreated (appointmentType: AppointmentType) {
      this.appointmentTypes.push(appointmentType)
      this.shouldShowAppointmentForm = false
      appointmentType.removed = false
      this.$router.push(`/appointment-types/${appointmentType.id}`)
    },

    /**
     * Returns the given duration of time in hours
     * @params minutes: Number of minutes
     */
    formatMinutes (minutes: number): string {
      return TimeService.minutesToHoursFormatted(minutes)
    },

    /**
     * Resets the new AppointmentType form data and shows the form
     */
    showAppointmentForm () {
      this.appointmentForm = {
        id: 0,
        name: '',
        description: '',
        duration: 60,
        public: true,
        isTask: false,
        removed: false,
        color: '#CCCCCC'
      }

      this.shouldShowAppointmentForm = true
    },

    /**
     * Show dropdown list of removed appointments
     */
    showRestoreAppointmentForm () {
      this.shouldRestoreType = true
    },

    /**
     * Restore appointment type that was removed
     */
    restoreAppointmentType (id: number) {
      if (window.confirm('Are you sure you want to Restore?')) {
        appointmentTypeService.restoreType(id).then(res => {
          this.appointmentTypes.push(res.data)
        })
      }
      this.shouldRestoreType = false
    },

    /**
     * Removes the given appointment type
     * @param: The offering
     */
    removeType (id: number) {
      if (window.confirm('Are you sure you want to Remove?')) {
        appointmentTypeService.removeType(id).then(res => {
          const ind = this.appointmentTypes.findIndex(at => at.id === id)
          if (ind !== -1) {
            this.appointmentTypes.splice(ind, 1)
          }
        })
      }
    }
  },

  components: {
    AppointmentTypeForm
  }
})
